<template>
  <!-- eslint-disable -->
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="codeLogs"
      :loading="loading"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    codeLogs: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "srsCodeLogId",
        },
        {
          text: "Date Created",
          value: "dateCreated",
        },
        {
          text: "Product Code",
          value: "productCode",
        },
        {
          text: "SRS old code",
          value: "srsCodeOld",
        },
        {
          text: "Srs new Code",
          value: "srsCodeNew",
        },
        {
          text: "IsUpdated",
          value: "isUpdated",
        },
      ],
    };
  },
};
</script>
